import React from 'react';
type SectionHeaderProps = {
  eyebrow: string;
  title: React.ReactNode;
  tone?: 'dark' | 'light';
  lead?: string;
};
export function SectionHeader({
  eyebrow,
  title,
  tone = 'light',
  lead
}: SectionHeaderProps) {
  const dark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-45" data-mp="11omhoyvg82g0">
      <p className={`font-display text-base font-bold uppercase tracking-[0.12em] sm:text-lg ${dark ? 'text-brand' : 'text-brand-dark'}`} data-id="element-46" data-mp="wqupe3qw6eba">
        {eyebrow}
      </p>
      <h2 className={`mt-3 text-balance font-display text-[2.4rem] font-extrabold uppercase leading-[0.98] sm:text-5xl lg:text-6xl ${dark ? 'text-white' : 'text-ink'}`} data-id="element-47" data-mp="15su8d1lgvsgv">
        {title}
      </h2>
      {lead && <p className={`mt-5 text-lg leading-relaxed ${dark ? 'text-slate-300' : 'text-slate-600'}`} data-id="element-48" data-mp="1fjoum5ypqs2b">{lead}</p>}
    </div>;
}